export class Catalogo {
    ncatalogoId: number;
    ncatalogoIdtipo: number;
    ccatalogoDsc: string;
    ccatalogoFlgactivo: string;
}
